const addZero = (i) => (i < 10 ? `0${i}` : i);

export const convertToUTC = (time: string) => {
  const times = time.split(':');
  const date = new Date();
  date.setHours(Number(times[0]), Number(times[1]), Number(times[2]));

  return `${addZero(date.getUTCHours())}:${addZero(date.getUTCMinutes())}:${addZero(date.getUTCSeconds())}`;
};

export const convertToLocal = (time: string) => {
  const times = time.split(':');
  const date = new Date();
  date.setUTCHours(Number(times[0]), Number(times[1]), Number(times[2]));

  return `${addZero(date.getHours())}:${addZero(date.getMinutes())}:${addZero(date.getSeconds())}`;
};
